var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.signer)?_c('div',{staticClass:"scanner"},[_c('qrcode-stream',{attrs:{"camera":_vm.camera},on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1):_vm._e(),_c('div',{staticClass:"error"},[_vm._v(_vm._s(this.scanError))])])}
var staticRenderFns = []

export { render, staticRenderFns }